<template>
         <ServiceCode :AllowEdit="true"></ServiceCode>
</template>

<script>
import ServiceCode from '@/components/DPEBB/Administrator/ServiceCode.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function () {
        return {
            AppServiceID :6,
        }
    },
    components: {
        ServiceCode  : ServiceCode
    },
 created: function() {
    this.AppServiceID = this.$store.getters.GetDPEBBServiceID;
    this.$emit('update:layout', LayoutDefault);
},   
 beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
    
}
</script>

<style>

</style>
